import { useApi } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import { Flex, DisplaySwitch } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import HistoricGraphs from './HistoricGraphs';

export default function HistoricTabs() {
  const [activeDisplayOption, setActiveDisplayOption] = useState('debt');
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const displayOptions = useMemo(() => [{ key: 'debt', value: 'Debt' }], []);

  const [data, error] = useApi({
    url: `/rwa/historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }

  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  if (data) {
    return (
      <Flex flexDirection="column" gap="xs">
        <DisplaySwitch
          data={displayOptions}
          activeOption={activeDisplayOption}
          onChange={setActiveDisplayOption}
        />

        <HistoricGraphs
          data={data}
          type={activeDisplayOption}
          timeFilter={timeFilter}
          chartDaysAgo={chartDaysAgo}
        />
      </Flex>
    );
  }
  return <ChartSkeleton />;
}
